/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// utilities for measuring and logging performance
import AjsLog from "./SendToAjs";
import { getQueryParameterFromUrl } from "dc-preview-utils/src/Utils/UrlUtils";
import { getFileNameFromURL } from "utils/filename";
import { getRecordedTimings, getPageRenderTimes, getViewerInitTime } from "utils/performance";
import { getBrowser } from "dc-preview-utils/src/Utils/UserAgentUtils";
import { getOS } from "dc-preview-utils/src/Utils/DeviceUtils";
import { docViewModes } from "constants/enums";
import { getViewMode } from "selectors/viewModeSelectors";
import { getInitialPageIndex } from "selectors/pagedViewState";

export const isPerformanceLoggingEnabled = () =>
  getQueryParameterFromUrl(window.location.href, "enableLogging") === "true" && getSessionId();

const getSessionId = () => getQueryParameterFromUrl(window.location.href, "sessionId");

let isInHouseLoggingDone = false;

export const resetInHouseLogging = () => {
  isInHouseLoggingDone = false;
};

export const initiatePerfLogging = (stores, docApi, index, totalPages) => {
  if (isPerformanceLoggingEnabled() && !isInHouseLoggingDone && (totalPages === 1 || index === 1)) {
    console.log("--> initiating perf logging");
    const sessionId = getSessionId();
    const fileName = getFileNameFromURL(stores, window.location.href);
    const viewerInitTime = getViewerInitTime();
    const uaDetails = {
      browser: getBrowser(),
      os: getOS()
    };
    const firstVisiblePageIndex = getInitialPageIndex(stores);
    if (getViewMode(stores) === docViewModes.NON_PDF) {
      AjsLog({
        sessionId,
        fileName,
        viewerInitTime,
        totalPages,
        ...getRecordedTimings(),
        uaDetails,
        firstVisiblePageIndex
      });
    } else {
      AjsLog({
        sessionId,
        fileName,
        viewerInitTime,
        ...getPageRenderTimes(),
        totalPages,
        ...getRecordedTimings(),
        uaDetails,
        firstVisiblePageIndex
      });
    }
    isInHouseLoggingDone = true;
  }
};
